module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "FundacaoCode12646546516581"
    }
  }, [_vm._m(0), _vm._v(" "), _c('RelatorioTitulo', {
    staticClass: "fbbpage01",
    attrs: {
      "valor": "Dados do Projeto"
    }
  }, [_c('div', {
    staticClass: "fbb-grid"
  }, [_c('div', {
    staticClass: "fbb-col-span-12"
  }, [_c('RelatorioTextoDestaque', {
    attrs: {
      "titulo": "Título do projeto",
      "valor": _vm.limpaCampo(_vm.dadosRelatorio.cabecalho.projeto)
    }
  }), _vm._v(" "), _c('RelatorioTextoDestaque', {
    attrs: {
      "titulo": "Convenente",
      "valor": _vm.limpaCampo(_vm.dadosRelatorio.cabecalho.entidade)
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "fbb-col-span-6"
  }, [_c('RelatorioTextoDestaque', {
    attrs: {
      "titulo": "Número do projeto",
      "valor": _vm.limpaCampo(_vm.dadosRelatorio.cabecalho.numero_projeto)
    }
  }), _vm._v(" "), _c('RelatorioTextoDestaque', {
    attrs: {
      "titulo": "Início de execução do projeto",
      "valor": _vm.limpaCampo(_vm.dadosRelatorio.cabecalho.inicio)
    }
  }), _vm._v(" "), _c('RelatorioTextoDestaque', {
    attrs: {
      "titulo": "Percentual financeiro realizado",
      "valor": _vm.limpaCampo(_vm.dadosRelatorio.cabecalho.percentual_liberacao)
    }
  }), _vm._v(" "), _c('RelatorioTextoDestaque', {
    attrs: {
      "titulo": "E-mail de contato",
      "valor": _vm.limpaCampo(_vm.dadosRelatorio.cabecalho.email_contato)
    }
  }), _vm._v(" "), _c('RelatorioTextoDestaque', {
    attrs: {
      "titulo": "Telefone 01",
      "valor": _vm.limpaCampo(_vm.dadosRelatorio.cabecalho.telefone_contato_1)
    }
  }), _vm._v(" "), (_vm.dadosRelatorio.objeto.length > 0) ? _c('RelatorioTextoDestaque', {
    attrs: {
      "titulo": "Objeto cumprido?",
      "valor": _vm.limpaCampo(_vm.dadosRelatorio.objeto)
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "fbb-col-span-6"
  }, [_c('RelatorioTextoDestaque', {
    attrs: {
      "titulo": "Tipo de relatório",
      "valor": _vm.limpaCampo(_vm.dadosRelatorio.tipo_relatorio)
    }
  }), _vm._v(" "), _c('RelatorioTextoDestaque', {
    attrs: {
      "titulo": "Fim de execução do projeto",
      "valor": _vm.limpaCampo(_vm.dadosRelatorio.cabecalho.termino)
    }
  }), _vm._v(" "), _c('RelatorioTextoDestaque', {
    attrs: {
      "titulo": "Percentual de tempo decorrido",
      "valor": _vm.limpaCampo(_vm.dadosRelatorio.cabecalho.percentual_andamento)
    }
  }), _vm._v(" "), _c('RelatorioTextoDestaque', {
    attrs: {
      "titulo": "Contrapartida Executada",
      "valor": ((_vm.contrapartidaConsolidada.toFixed(2)) + " %")
    }
  }), _vm._v(" "), _c('RelatorioTextoDestaque', {
    attrs: {
      "titulo": "Telefone 02",
      "valor": _vm.limpaCampo(_vm.dadosRelatorio.cabecalho.telefone_contato_2)
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "html2pdf__page-break"
  })]), _vm._v(" "), _c('RelatorioTitulo', {
    staticClass: "fbbpage02",
    attrs: {
      "valor": "Metas e Atividades"
    }
  }, [_c('div', {
    staticClass: "fbb-grid"
  }, [_c('div', {
    staticClass: "fbb-col-span-12 fbb-flex"
  }, [_c('div', {
    staticClass: "titulo-tabela"
  }, [_vm._v("metas")]), _vm._v(" "), _c('div', {
    staticClass: "titulo-tabela"
  }, [_vm._v("atividades")])]), _vm._v(" "), _c('div', {
    staticClass: "fbb-col-span-12 fbb-flex"
  }, [_c('div', {
    staticClass: "titulo-tabela-2",
    staticStyle: {
      "width": "30%"
    }
  }, [_vm._v("Descrição")]), _vm._v(" "), _c('div', {
    staticClass: "titulo-tabela-2",
    staticStyle: {
      "width": "5%"
    }
  }, [_vm._v("Orçado")]), _vm._v(" "), _c('div', {
    staticClass: "titulo-tabela-2",
    staticStyle: {
      "width": "7%"
    }
  }, [_vm._v("Realizado")]), _vm._v(" "), _c('div', {
    staticClass: "titulo-tabela-2",
    staticStyle: {
      "width": "8%"
    }
  }, [_vm._v("Atingimento")]), _vm._v(" "), _c('div', {
    staticClass: "titulo-tabela-2",
    staticStyle: {
      "width": "25%"
    }
  }, [_vm._v("Descricão")]), _vm._v(" "), _c('div', {
    staticClass: "titulo-tabela-2",
    staticStyle: {
      "width": "12.5%"
    }
  }, [_vm._v("Status")]), _vm._v(" "), _c('div', {
    staticClass: "titulo-tabela-2",
    staticStyle: {
      "width": "12.5%"
    }
  }, [_vm._v("Execução")])]), _vm._v(" "), _vm._l((_vm.dadosRelatorio.metas.row), function(meta) {
    return _c('div', {
      staticClass: "fbb-col-span-12 fbb-flex"
    }, [_c('div', {
      staticClass: "tabela-body",
      staticStyle: {
        "width": "30%"
      }
    }, [_vm._v(_vm._s(meta.meta))]), _vm._v(" "), _c('div', {
      staticClass: "tabela-body",
      staticStyle: {
        "width": "5%"
      }
    }, [_vm._v(_vm._s(meta.orcado))]), _vm._v(" "), _c('div', {
      staticClass: "tabela-body",
      staticStyle: {
        "width": "7%"
      }
    }, [_vm._v(_vm._s(meta.realizado))]), _vm._v(" "), _c('div', {
      staticClass: "tabela-body",
      staticStyle: {
        "width": "8%"
      }
    }, [_vm._v(_vm._s(_vm._f("percentage")((meta.realizado / meta.orcado))))]), _vm._v(" "), _c('div', {
      staticClass: "tabela-body",
      staticStyle: {
        "width": "50%",
        "height": "100%"
      }
    }, _vm._l((meta.atividades.row), function(atividade) {
      return _c('div', {
        staticStyle: {
          "width": "100%",
          "height": "auto"
        }
      }, [_c('div', {
        staticClass: "fbb-flex"
      }, [_c('div', {
        staticClass: "tabela-body",
        staticStyle: {
          "width": "50%"
        }
      }, [_vm._v(_vm._s(atividade.atividade))]), _vm._v(" "), _c('div', {
        staticClass: "tabela-body",
        staticStyle: {
          "width": "25%"
        }
      }, [_vm._v(_vm._s(_vm.retornaSituacao(atividade.status)))]), _vm._v(" "), _c('div', {
        staticClass: "tabela-body",
        staticStyle: {
          "width": "25%"
        }
      }, [_vm._v(_vm._s(atividade.execucao) + " %")])]), _vm._v(" "), _c('div', {
        staticClass: "titulo-tabela",
        staticStyle: {
          "width": "100%"
        }
      }, [_vm._v("Arquivos")]), _vm._v(" "), _vm._l((atividade.anexos_atividades.row), function(anexo) {
        return _c('div', [_vm._v(_vm._s(anexo.ds_nome_arquivo))])
      })], 2)
    }), 0)])
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "html2pdf__page-break"
  })]), _vm._v(" "), _c('RelatorioTitulo', {
    staticClass: "fbbpage03",
    attrs: {
      "valor": "Justificativa pelo não atingimento de meta"
    }
  }, [_c('div', {
    staticClass: "fbb-grid"
  }, [_c('div', {
    staticClass: "fbb-col-span-12 fbb-flex"
  }, [_c('div', {
    staticClass: "titulo-tabela",
    staticStyle: {
      "width": "30%"
    }
  }, [_vm._v("Meta / Atividade")]), _vm._v(" "), _c('div', {
    staticClass: "titulo-tabela",
    staticStyle: {
      "width": "30%"
    }
  }, [_vm._v("Objetivo")]), _vm._v(" "), _c('div', {
    staticClass: "titulo-tabela",
    staticStyle: {
      "width": "30%"
    }
  }, [_vm._v("Providência")]), _vm._v(" "), _c('div', {
    staticClass: "titulo-tabela",
    staticStyle: {
      "width": "10%"
    }
  }, [_vm._v("Prazo")])]), _vm._v(" "), _vm._l((_vm.executadasparcial.filter(function (item) { return item.providencia != ''; })), function(executadaParcial) {
    return (_vm.executadasparcial && _vm.executadasparcial.length > 0) ? _c('div', {
      staticClass: "fbb-col-span-12 fbb-flex"
    }, [_c('div', {
      staticClass: "tabela-body",
      staticStyle: {
        "width": "30%",
        "text-align": "justify"
      }
    }, [_c('div', [_c('strong', [_vm._v(_vm._s(_vm.limpaCampo(executadaParcial.meta)))])]), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.limpaCampo(executadaParcial.atividade)))])]), _vm._v(" "), _c('div', {
      staticClass: "tabela-body",
      staticStyle: {
        "width": "30%",
        "text-align": "justify"
      }
    }, [_vm._v(_vm._s(_vm.limpaCampo(executadaParcial.motivo)))]), _vm._v(" "), _c('div', {
      staticClass: "tabela-body",
      staticStyle: {
        "width": "30%",
        "text-align": "justify"
      }
    }, [_vm._v(_vm._s(_vm.limpaCampo(executadaParcial.providencia)))]), _vm._v(" "), _c('div', {
      staticClass: "tabela-body",
      staticStyle: {
        "width": "10%",
        "text-align": "justify"
      }
    }, [_vm._v(_vm._s(_vm._f("formataData")(executadaParcial.prazo_regularizacao_meta)) + "\n          ")])]) : _vm._e()
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "html2pdf__page-break"
  })]), _vm._v(" "), (_vm.executadasparcial && _vm.naoexecutadas.length > 0) ? _c('RelatorioTitulo', {
    staticClass: "fbbpage04",
    attrs: {
      "valor": "Justificativa pela não execução da atividade"
    }
  }, [_c('div', {
    staticClass: "fbb-grid"
  }, [_c('div', {
    staticClass: "fbb-col-span-12 fbb-flex"
  }, [_c('div', {
    staticClass: "titulo-tabela",
    staticStyle: {
      "width": "22.5%"
    }
  }, [_vm._v("Meta")]), _vm._v(" "), _c('div', {
    staticClass: "titulo-tabela",
    staticStyle: {
      "width": "22.5%"
    }
  }, [_vm._v("Atividade")]), _vm._v(" "), _c('div', {
    staticClass: "titulo-tabela",
    staticStyle: {
      "width": "22.5%"
    }
  }, [_vm._v("Motivo")]), _vm._v(" "), _c('div', {
    staticClass: "titulo-tabela",
    staticStyle: {
      "width": "22.5%"
    }
  }, [_vm._v("Providências")]), _vm._v(" "), _c('div', {
    staticClass: "titulo-tabela",
    staticStyle: {
      "width": "10%"
    }
  }, [_vm._v("Prazo")])]), _vm._v(" "), _vm._l((_vm.naoexecutadas), function(naoexecutada) {
    return _c('div', {
      staticClass: "fbb-col-span-12 fbb-flex"
    }, [_c('div', {
      staticClass: "tabela-body",
      staticStyle: {
        "width": "22.5%",
        "text-align": "justify"
      }
    }, [_vm._v(_vm._s(_vm.limpaCampo(naoexecutada.meta)))]), _vm._v(" "), _c('div', {
      staticClass: "tabela-body",
      staticStyle: {
        "width": "22.5%",
        "text-align": "justify"
      }
    }, [_vm._v(_vm._s(_vm.limpaCampo(naoexecutada.atividade)))]), _vm._v(" "), _c('div', {
      staticClass: "tabela-body",
      staticStyle: {
        "width": "22.5%",
        "text-align": "justify"
      }
    }, [_vm._v(_vm._s(_vm.limpaCampo(naoexecutada.motivo)))]), _vm._v(" "), _c('div', {
      staticClass: "tabela-body",
      staticStyle: {
        "width": "22.5%",
        "text-align": "justify"
      }
    }, [_vm._v(_vm._s(_vm.limpaCampo(naoexecutada.providencia)))]), _vm._v(" "), _c('div', {
      staticClass: "tabela-body",
      staticStyle: {
        "width": "10%",
        "text-align": "justify"
      }
    }, [_vm._v(_vm._s(_vm._f("formataData")(naoexecutada.prazo_regularizacao_atividade)) + "\n          ")])])
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "html2pdf__page-break"
  })]) : _vm._e(), _vm._v(" "), _c('RelatorioTitulo', {
    staticClass: "fbbpage04",
    attrs: {
      "valor": "Número de participantes envolvidos atualmente no projeto"
    }
  }, [_c('div', {
    staticClass: "fbb-grid"
  }, [_c('div', {
    staticClass: "fbb-col-span-12 fbb-flex"
  }, [_c('div', {
    staticClass: "titulo-tabela"
  }, [_vm._v("Público")]), _vm._v(" "), _c('div', {
    staticClass: "titulo-tabela"
  }, [_vm._v("Previsto")]), _vm._v(" "), _c('div', {
    staticClass: "titulo-tabela"
  }, [_vm._v("Realizado")])]), _vm._v(" "), _c('div', {
    staticClass: "fbb-col-span-12 fbb-flex"
  }, [_c('div', {
    staticClass: "tabela-body",
    staticStyle: {
      "width": "100%"
    }
  }, [_vm._v("Participantes")]), _vm._v(" "), _c('div', {
    staticClass: "tabela-body",
    staticStyle: {
      "width": "100%"
    }
  }, [_vm._v(_vm._s(_vm.previstoPublicoAlvo.participantes))]), _vm._v(" "), _c('div', {
    staticClass: "tabela-body",
    staticStyle: {
      "width": "100%"
    }
  }, [_vm._v(_vm._s(_vm.totalizadores.participantes))])]), _vm._v(" "), _c('div', {
    staticClass: "fbb-col-span-12 fbb-flex"
  }, [_c('div', {
    staticClass: "tabela-body",
    staticStyle: {
      "width": "100%"
    }
  }, [_vm._v("Jovens")]), _vm._v(" "), _c('div', {
    staticClass: "tabela-body",
    staticStyle: {
      "width": "100%"
    }
  }, [_vm._v(_vm._s(_vm.previstoPublicoAlvo.jovens))]), _vm._v(" "), _c('div', {
    staticClass: "tabela-body",
    staticStyle: {
      "width": "100%"
    }
  }, [_vm._v(_vm._s(_vm.totalizadores.jovens))])]), _vm._v(" "), _c('div', {
    staticClass: "fbb-col-span-12 fbb-flex"
  }, [_c('div', {
    staticClass: "tabela-body",
    staticStyle: {
      "width": "100%"
    }
  }, [_vm._v("Mulheres")]), _vm._v(" "), _c('div', {
    staticClass: "tabela-body",
    staticStyle: {
      "width": "100%"
    }
  }, [_vm._v(_vm._s(_vm.previstoPublicoAlvo.mulheres))]), _vm._v(" "), _c('div', {
    staticClass: "tabela-body",
    staticStyle: {
      "width": "100%"
    }
  }, [_vm._v(_vm._s(_vm.totalizadores.mulheres))])])])]), _vm._v(" "), _c('RelatorioTitulo', {
    staticClass: "fbbpage05",
    attrs: {
      "valor": "O cronograma físico-financeiro está sendo executado conforme previsto?"
    }
  }, [_c('div', {
    staticClass: "area-de-texto-impressao"
  }, [_vm._v(_vm._s(_vm.retornaAplicacao(_vm.dadosRelatorio.cronograma_conforme_previsto.resposta)) + "\n      ")])]), _vm._v(" "), _c('RelatorioTitulo', {
    staticClass: "fbbpage05",
    attrs: {
      "valor": "A contrapartida está sendo comprovada de acordo com o previsto no Plano de Trabalho?"
    }
  }, [_c('div', {
    staticClass: "area-de-texto-impressao"
  }, [_vm._v("\n        " + _vm._s(_vm.retornaAplicacao(_vm.dadosRelatorio.contrapartida_comprovada_previsto.resposta)) + "\n      ")])]), _vm._v(" "), _c('RelatorioTitulo', {
    staticClass: "fbbpage05",
    attrs: {
      "valor": "Foram realizadas as ações de divulgação previstas no Projeto?"
    }
  }, [_c('div', {
    staticClass: "area-de-texto-impressao"
  }, [_vm._v(_vm._s(_vm.dadosRelatorio.acoes_divulgacao_prevista.justificativa))]), _vm._v(" "), (_vm.paginas[4] && _vm.paginas[4].quebra) ? _c('div', {
    staticClass: "html2pdf__page-break"
  }) : _vm._e()]), _vm._v(" "), _c('RelatorioTitulo', {
    staticClass: "fbbpage05",
    attrs: {
      "valor": "Informar como está o desenvolvimento do Objeto do Convênio:"
    }
  }, [_c('div', {
    staticClass: "area-de-texto-impressao"
  }, [_vm._v(_vm._s(_vm.dadosRelatorio.desenvolvimento_objeto_convenio.valor))]), _vm._v(" "), _c('div', {
    staticClass: "html2pdf__page-break"
  })]), _vm._v(" "), _c('RelatorioTitulo', {
    staticClass: "fbbpage06",
    attrs: {
      "valor": "Informar sobre o alcance dos Objetivos do projeto:"
    }
  }, [_c('div', {
    staticClass: "fbb-grid"
  }, [_c('div', {
    staticClass: "fbb-col-span-12 fbb-flex"
  }, [_c('div', {
    staticClass: "titulo-tabela"
  }, [_vm._v("Item")]), _vm._v(" "), _c('div', {
    staticClass: "titulo-tabela"
  }, [_vm._v("Descrição")]), _vm._v(" "), _c('div', {
    staticClass: "titulo-tabela"
  }, [_vm._v("Realizado")])]), _vm._v(" "), _vm._l((_vm.dadosRelatorio.objetivos_projeto.row), function(objProj) {
    return _c('div', {
      staticClass: "fbb-col-span-12 fbb-flex"
    }, [_c('div', {
      staticClass: "tabela-body",
      staticStyle: {
        "width": "100%",
        "text-align": "justify"
      }
    }, [_vm._v(_vm._s(objProj.item))]), _vm._v(" "), _c('div', {
      staticClass: "tabela-body",
      staticStyle: {
        "width": "100%",
        "text-align": "justify"
      }
    }, [_vm._v(_vm._s(objProj.descricao))]), _vm._v(" "), _c('div', {
      staticClass: "tabela-body",
      staticStyle: {
        "width": "100%",
        "text-align": "justify"
      }
    }, [_vm._v(_vm._s(objProj.realizado))])])
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "html2pdf__page-break"
  })]), _vm._v(" "), _c('RelatorioTitulo', {
    staticClass: "fbbpage07",
    attrs: {
      "valor": "Resultados alcançados até o momento:"
    }
  }, [_c('div', {
    staticClass: "area-de-texto-impressao"
  }, [_vm._v(_vm._s(_vm.dadosRelatorio.resultados_alcancados.valor))])]), _vm._v(" "), _c('RelatorioTitulo', {
    staticClass: "fbbpage07",
    attrs: {
      "valor": "Depoimentos:"
    }
  }, [_c('div', {
    staticClass: "area-de-texto-impressao"
  }, [_vm._v(_vm._s(_vm.dadosRelatorio.depoimentos.valor))])]), _vm._v(" "), _c('RelatorioTitulo', {
    staticClass: "fbbpage07",
    attrs: {
      "valor": "O Projeto contribui para a comercialização da produção?"
    }
  }, [_c('div', {
    staticClass: "area-de-texto-impressao"
  }, [_vm._v(_vm._s(_vm.retornaAplicacao(_vm.dadosRelatorio.comercializacao_producao.resposta)) + "\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "html2pdf__page-break"
  })]), _vm._v(" "), _c('RelatorioTitulo', {
    staticClass: "fbbpage08",
    attrs: {
      "valor": "O Projeto contribui para o desenvolvimento de novos conhecimentos/habilidades?"
    }
  }, [_c('div', {
    staticClass: "area-de-texto-impressao"
  }, [_c('span', {
    staticClass: "negrito"
  }, [_vm._v("Nível de 1 a 5:  ")]), _vm._v(_vm._s(_vm.dadosRelatorio.questionario.questao_1.resposta) + "\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "area-de-texto-impressao"
  }, [_vm._v(_vm._s(_vm.dadosRelatorio.questionario.questao_1.consideracoes))])]), _vm._v(" "), _c('RelatorioTitulo', {
    staticClass: "fbbpage08",
    attrs: {
      "valor": "O Projeto contribui para o envolvimento de mulheres e jovens?"
    }
  }, [_c('div', {
    staticClass: "area-de-texto-impressao"
  }, [_c('span', {
    staticClass: "negrito"
  }, [_vm._v("Nível de 1 a 5:  ")]), _vm._v("\n        " + _vm._s(_vm.dadosRelatorio.questionario.questao_2.resposta) + "\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "area-de-texto-impressao"
  }, [_vm._v(_vm._s(_vm.dadosRelatorio.questionario.questao_2.consideracoes))])]), _vm._v(" "), _c('RelatorioTitulo', {
    staticClass: "fbbpage08",
    attrs: {
      "valor": "O Projeto contribui para a formação de novas parcerias além da Fundação Banco do Brasil?"
    }
  }, [_c('div', {
    staticClass: "area-de-texto-impressao"
  }, [_c('span', {
    staticClass: "negrito"
  }, [_vm._v("Nível de 1 a 5:  ")]), _vm._v("\n        " + _vm._s(_vm.dadosRelatorio.questionario.questao_3.resposta) + "\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "area-de-texto-impressao"
  }, [_vm._v(_vm._s(_vm.dadosRelatorio.questionario.questao_3.consideracoes))]), _vm._v(" "), _c('div', {
    staticClass: "html2pdf__page-break"
  })]), _vm._v(" "), _c('RelatorioTitulo', {
    staticClass: "fbbpage08",
    attrs: {
      "valor": "O Projeto contribui para o surgimento de novas oportunidades de trabalho e/ou renda?"
    }
  }, [_c('div', {
    staticClass: "area-de-texto-impressao"
  }, [_c('span', {
    staticClass: "negrito"
  }, [_vm._v("Nível de 1 a 5:  ")]), _vm._v("\n        " + _vm._s(_vm.dadosRelatorio.questionario.questao_4.resposta) + "\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "area-de-texto-impressao"
  }, [_vm._v(_vm._s(_vm.dadosRelatorio.questionario.questao_4.consideracoes))])]), _vm._v(" "), _c('RelatorioTitulo', {
    staticClass: "fbbpage09",
    attrs: {
      "valor": "O Projeto contribui para a preservação do meio ambiente e o cuidado ambiental?"
    }
  }, [_c('div', {
    staticClass: "area-de-texto-impressao"
  }, [_c('span', {
    staticClass: "negrito"
  }, [_vm._v("Nível de 1 a 5:  ")]), _vm._v(_vm._s(_vm.dadosRelatorio.questionario.questao_5.resposta) + "\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "area-de-texto-impressao"
  }, [_vm._v(_vm._s(_vm.dadosRelatorio.questionario.questao_5.consideracoes))])]), _vm._v(" "), _c('RelatorioTitulo', {
    staticClass: "fbbpage09",
    attrs: {
      "valor": "O Projeto contribui para a valorização de questões relativas a direitos humanos?"
    }
  }, [_c('div', {
    staticClass: "area-de-texto-impressao"
  }, [_c('span', {
    staticClass: "negrito"
  }, [_vm._v("Nível de 1 a 5:  ")]), _vm._v(_vm._s(_vm.dadosRelatorio.questionario.questao_6.resposta) + "\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "area-de-texto-impressao"
  }, [_vm._v(_vm._s(_vm.dadosRelatorio.questionario.questao_6.consideracoes))]), _vm._v(" "), _c('div', {
    staticClass: "html2pdf__page-break"
  })]), _vm._v(" "), _c('RelatorioTitulo', {
    staticClass: "fbbpage09",
    attrs: {
      "valor": "Conclusão do relatório"
    }
  }, [_c('div', {
    staticClass: "area-de-texto-impressao"
  }, [_vm._v(_vm._s(_vm.dadosRelatorio.parecer_fbb.valor))])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "fbbpage01 fbb-cabecalho-relatorio"
  }, [_c('div', [_c('img', {
    attrs: {
      "src": "/static/img/logo-login.png"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "titulo-relatorio"
  }, [_vm._v("\n        Relatório de Execução\n      ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-6d220210!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/relatorios/RelatorioImpressaoBNDES.vue
// module id = 2000
// module chunks = 1